import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import * as React from "react";
import { useSelector } from "react-redux";
import { useAppTheme } from "../store/config/hooks";

const lightTheme=createMuiTheme({
    palette:{
        type:"light",
        error:{
            main:"#f44336"
        }
    }
})
const darkTheme=createMuiTheme({
    palette:{
        type:"dark",
    }
})

const getTheme=(theme)=>{
    if(theme==="light"){
        return lightTheme;
    }else{
        return darkTheme
    }
}

const Theme=(props)=>{
    const {children}=props;
     const { selectedTheme } = useAppTheme();
    return(
        <ThemeProvider theme={getTheme(selectedTheme)}>{children}</ThemeProvider>
    )
}
export default Theme;
